import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";

import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import { isApiResponse, isReportAccess, date_range_config, reactSelectStyles,user_activities } from '../../helpers/utils.js';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import BtidFilter from '../../filters/BtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2020-02-01','1');
var BankTidTable='';

class RelianceBankUtidReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            txnLists:[{value:'Leg1 QR Transaction', label: 'Leg1'},{value:'Leg2 QR Transaction', label: 'Leg2'}],
            txnValue:'',
            txnIds:'',
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            statusLists: [{value: 'Active', label: 'Active'}, {value: 'Inactive', label: 'Inactive'}],
            status: "",
            statusValue: null,
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isSettledLists: [{value: 'Settled', label: 'Settled'},{value: 'Unsettled', label: 'Unsettled'},{value: 'Reversal', label: 'Reversal'}, {value: 'Void', label: 'Void'},{value: 'Failed', label: 'Failed'}],
            isSettledIDs: '',
            isSettledValue: null,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            cibtidList: [],
            cibtidValue: null,
            cibtidIds: '',
            is_btid_loading: true,
            btidListOpen: false,
            btidHeaderTitle: "Select [BTID]",
            fetch_data:false
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions,'bank_tid_report');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
        }
    componentDidUpdate() {

    }

    componentDidMount() {
        this.get_filtered_bank_tid_report(this.state.object_type,this.state.object_code,'')
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'reliance_bank_utid_report','sparcs')
    }
    get_filtered_bank_tid_report(object_type, object_code, event) {
        var that = this;


        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            active_mids: merchants,
            active_cids: chains,
            active_sids: stores,
            active_bids: this.state.acqBankIds,
            active_cityids: this.state.cityIds,
            active_transaction_type: this.state.txnTypeIDs,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_utid: this.state.ciutidIds,
            active_is_settled: this.state.isSettledIDs,
            active_txnIds: this.state.txnIds,
            active_is_prim_id: this.state.is_prim_id,
            active_is_posbillinput: this.state.is_posbillinput,
        })
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            btid: this.state.cibtidIds,
            acq_bank_codes: this.state.acqBankIds,
            pos_status: this.state.status
        };
        if ($.fn.DataTable.isDataTable('#BankTidTable')) {
            $('#BankTidTable').DataTable().clear().destroy();
        }
        var BankTidTable = $('#BankTidTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/reliance-bank-utid-reports/",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [

                    {"data":"Store Name", "width":"100px"},
                    {"data":"Acquirer", "width":"100px"},
                    {"data":"UTID"},
                    {"data":"Hardware ID"},
                    // {"data": "Acquirer Bank"},
                    {"data":"Hardware Model"},
                    {"data":"Host"},
                    {"data":"POS Status"},
                    {"data":"Last Transaction Date"},
                    {"data":"POS Installation Date"},
                    {"data":"DBA Name"},
                    {"data":"DBA Address"},
                    {"data":"DBA City"},
                    {"data":"Store Code"},
                    {"data":"Mer Store Code"},
                    {"data":"Store Address"},
                    {"data":"City"},
                    {"data":"PinCode"},
                    {"data":"Contact No." },
                    {"data":"Billing Entity" },
                    {"data":"SBI TID" },
                    {"data":"SBI MID" },
                    {"data":"AMEX TID" },
                    {"data":"AMEX MID" },
                    {"data":"UNION CC TID" },
                    {"data":"UNION CC MID" },
                    {"data":"UNION DC TID" },
                    {"data":"UNION DC MID" },
                    {"data":"HDFC BANK TID" },
                    {"data":"HDFC BANK MID" },
                    {"data":"HDFC UPI TID" },
                    {"data":"HDFC UPI MID" },
                    {"data":"AXIS CC TID" },
                    {"data":"AXIS CC MID" },
                    {"data":"AXIS DC TID" },
                    {"data":"AXIS DC MID" },
                    {"data":"AXIS UPI TID" },
                    {"data":"AXIS UPI MID" },
                    {"data":"YES CC TID" },
                    {"data":"YES CC MID" },
                    {"data":"YES DC TID" },
                    {"data":"YES DC MID" },
                    {"data":"ICICI BANK TID" },
                    {"data":"ICICI BANK MID" },
                    {"data":"ICICI UPI TID" },
                    {"data":"ICICI UPI MID" },
                    {"data":"KOTAK MAHINDRA BANK TID" },
                    {"data":"KOTAK MAHINDRA BANK MID" },
                    {"data":"CITIBANK CC TID" },
                    {"data":"CITIBANK CC MID" },
                    {"data":"CITIBANK DC TID" },
                    {"data":"CITIBANK DC MID" },
                    {"data":"R-ONE SAVINGS TID" },
                    {"data":"R-ONE SAVINGS MID" },
                    {"data":"LOYLTY REWARDZ TID" },
                    {"data":"LOYLTY REWARDZ MID" },
                    {"data":"JIO MONEY TID" },
                    {"data":"JIO MONEY MID" },
                    {"data":"COUPON TID" },
                    {"data":"COUPON MID" },
                    {"data":"LOYALTY VOUCHER TID" },
                    {"data":"LOYALTY VOUCHER MID" },
                    {"data":"PREPAID TID" },
                    {"data":"PREPAID MID" },
                    {"data":"PLUXEE TID" },
                    {"data":"PLUXEE MID" }


                ],
                "columnDefs": [
                    {  render: function (data) {
                            if(data===null || data==''){
                                return '<td >'+data+'</td>';
                            } else {
                                return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                            }
                        },
                        "width": "80px",

                    },
                    {  render: function (data) {
                        if(data===null || data==''){
                            return '<td >'+data+'</td>';
                        } else {
                            return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                        }

                        },
                        "width": "80px",

                    },
                    {  render: function (data) {
                            if(data===null || data==''){
                                return '<td >'+data+'</td>';
                            } else {
                                return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                            }
                        },
                        "width": "80px",

                    },
                    {  render: function (data) {
                            if(data===null || data==''){
                                return '<td >'+data+'</td>';
                            } else {
                                return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                            }
                        },
                        "width": "80px",

                    },
                    {  render: function (data) {
                            if(data===null || data==''){
                                return '<td >'+data+'</td>';
                            } else {
                                return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                            }
                        },
                        "width": "80px",

                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },

                    }
                ],

            });

    }

    BankTidDownloadCheck(e){
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            end_date: this.state.todSend,
            start_date: this.state.yestSend,
            utid: this.state.ciutidIds,
            btid: this.state.cibtidIds,
            acquirers: this.state.acqBankIds,
            pos_status: this.state.status,
            download: 1
        }
        this.setState({
            filters:filters
        })
        if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds===''){
            confirmAlert({
            //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/report/reliance/bank/utid','reliance_bank_tid_report');
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/report/reliance/bank/utid','reliance_bank_tid_report');
        }
    }

    reset_all(e){

      if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
            this.refs.reloadBtid.ci_btid('', '','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
            this.refs.reloadBtid.ci_btid(this.state.object_code, '','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
            this.refs.reloadBtid.ci_btid('', this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
            this.refs.reloadBtid.ci_btid('', '',this.state.object_code,false,'');
        }
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            status: "",
            statusValue: [],
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            cibtidValue: [],
            cibtidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            traCurrencyValue:[],
            traCurrencyIDs:'',
            issuHomeCurrValue:[],
            issuHomeCurrIDs:'',
            campaignCodeValue:[],
            campaignCodeIDs:'',
            txnIds:'',
            txnValue:[],


        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }

    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });

    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
            cibtidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
        this.refs.reloadBtid.ci_btid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
            cibtidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
        this.refs.reloadBtid.ci_btid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
        this.refs.reloadBtid.ci_btid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }

    handleBtid = (btid) =>
    {
        this.setState({
            cibtidIds:btid,
            isChange: true
        });

    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    changeStatus(optionSelected){
        let value='';
        let statusArray = [];
        if(optionSelected.length < 1){
            value = null;
            statusArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                statusArray.push(mids.value)

            });
        }

        this.setState({
            status:statusArray,
            statusValue:optionSelected,
            isChange: true
        });

    }
    render() {

        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Reliance Bank UTID Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">

                                             {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Btid: </label>
                                                <BtidFilter ref = "reloadBtid" onSelectBtid = {this.handleBtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Acquirer:</label>
                                                <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Status: </label>
                                                <ReactMultiSelectCheckboxes name="status"
                                                    isMulti
                                                    value={this.state.statusValue}
                                                    styles={reactSelectStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeStatus.bind(this)}
                                                    options={this.state.statusLists}
                                                    placeholderButtonLabel="Select [Status]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_bank_tid_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.BankTidDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="BankTidTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th width="100px">Store</th>
                                                    <th>Acquirer</th>
                                                    <th>UTID</th>
                                                    <th>Hardware ID</th>

                                                    <th>Hardware Model</th>
                                                    <th>Host</th>
                                                    <th>POS Status</th>
                                                    <th>Last Transaction Date</th>
                                                    <th>POS Installation Date</th>
                                                    <th>DBA Name</th>
                                                    <th>DBA Address</th>
                                                    <th>DBA City</th>
                                                    <th>Store Code</th>
                                                    <th>Mer Store Code</th>
                                                    <th>Store Address</th>
                                                    <th>City</th>
                                                    <th>PinCode</th>
                                                    <th>Contact No.</th>
                                                    <th>Billing Entity</th>
                                                    <th>SBI TID</th>
                                                    <th>SBI MID</th>
                                                    <th>AMEX TID</th>
                                                    <th>AMEX MID</th>
                                                    <th>UNION CC TID</th>
                                                    <th>UNION CC MID</th>
                                                    <th>UNION DC TID</th>
                                                    <th>UNION DC MID</th>
                                                    <th>HDFC BANK TID</th>
                                                    <th>HDFC BANK MID</th>
                                                    <th>HDFC UPI TID</th>
                                                    <th>HDFC UPI MID</th>
                                                    <th>AXIS CC TID</th>
                                                    <th>AXIS CC MID</th>
                                                    <th>AXIS DC TID</th>
                                                    <th>AXIS DC MID</th>
                                                    <th>AXIS UPI TID</th>
                                                    <th>AXIS UPI MID</th>
                                                    <th>YES CC TID</th>
                                                    <th>YES CC MID</th>
                                                    <th>YES DC MID</th>
                                                    <th>YES DC MID</th>
                                                    <th>ICICI BANK TID</th>
                                                    <th>ICICI BANK MID</th>
                                                    <th>ICICI UPI TID</th>
                                                    <th>ICICI UPI MID</th>
                                                    <th>KOTAK MAHINDRA BANK TID</th>
                                                    <th>KOTAK MAHINDRA BANK MID</th>
                                                    <th>CITIBANK CC TID</th>
                                                    <th>CITIBANK CC MID</th>
                                                    <th>CITIBANK DC MID</th>
                                                    <th>CITIBANK DC MID</th>
                                                    <th>R-ONE SAVINGS TID</th>
                                                    <th>R-ONE SAVINGS MID</th>
                                                    <th>LOYLTY REWARDZ TID</th>
                                                    <th>LOYLTY REWARDZ MID</th>
                                                    <th>JIO MONEY TID</th>
                                                    <th>JIO MONEY MID</th>
                                                    <th>COUPON TID</th>
                                                    <th>COUPON MID</th>
                                                    <th>LOYALTY VOUCHER TID</th>
                                                    <th>LOYALTY VOUCHER MID</th>
                                                    <th>PREPAID TID</th>
                                                    <th>PREPAID MID</th>
                                                    <th>PLUXEE TID</th>
                                                    <th>PLUXEE MID</th>

                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( RelianceBankUtidReport );